import HeaderContent from "component/layout/HeaderContent";
import { observer, useLocalObservable } from "mobx-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TopHeader from "./component/TopHeader";
import TimelinePageStore from "./store/TimelinePageStore";
import TimelinePage from "./TimelinePage";
import TimeLineTopTabs from "./component/TimeLineTopTabs";
import EvalHeader from "./component/EvalHeader";
import TimelineGraphView from "pages/TimelinePage/TimelineGraphView";
import EmoticonCountHeader from "./component/EmoticonCountHeader";
import TimelineEmoticonView from "./TimelineEmoticonView";

function TimelinePageRouter() {
  const pageStore = useLocalObservable(() => new TimelinePageStore());

  return (
    <HeaderContent>
      <TopHeader isBackIcon isChangeIcon pageStore={pageStore} />
      <EvalHeader pageStore={pageStore} />
      <TimelineEmoticonView pageStore={pageStore} />
      {/* <EmoticonCountHeader pageStore={pageStore} /> */}
      <TimeLineTopTabs pageStore={pageStore} />
      {pageStore.isChecked ? (
        <TimelineGraphView pageStore={pageStore} />
      ) : (
        <TimelinePage pageStore={pageStore} />
      )}
    </HeaderContent>
  );
}
export default observer(TimelinePageRouter);
